// Tagalog (Filipino)
export default {
  nav: {
    home: 'Tahanan',
    wall: 'Ang Pader',
    groups: 'Mga Grupo',
    users: 'Mga Gumagamit',
    profile: 'Aking Profile',
    help: 'Tulong',
    membership: 'Membership',
    logout: 'Mag-logout',
    login: 'Mag-login'
  },
  auth: {
    loginSubtitle: 'Mag-login para magpatuloy',
    email: 'E-mail',
    password: 'Password',
    noAccount: 'Wala pang account?',
    createAccount: 'Gumawa ng account',
    loginFailed: 'Hindi matagumpay ang pag-login. Suriin ang iyong e-mail at password.',
    alreadyHaveAccount: 'Mayroon nang account?',
    register: 'Mag-register',
    name: 'Pangalan',
    confirmPassword: 'Kumpirmahin ang password',
    registrationSuccess: 'Nagawa na ang account! Maaari ka nang mag-login.',
    registrationFailed: 'Hindi magawa ang account.'
  },
  home: {
    title: 'Komunidad',
    tagline: 'Isang tahimik na lugar sa internet – walang mga ads.',
    description: 'Ibahagi ang pang-araw-araw na buhay sa pamilya, mga kaibigan at mga bagong kakilala. Walang ingay, walang pagsubaybay, walang pagbebenta ng data.',
    features: {
      noAds: 'Walang ads',
      simple: 'Simple at malinaw',
      safe: 'Ligtas na kapaligiran + moderasyon'
    },
    cta: {
      openWall: 'Buksan ang Pader',
      createProfile: 'Gumawa ng libreng profile',
      goToWall: 'Pumunta sa Pader',
      readMore: 'Basahin ang tungkol sa ideya'
    },
    pricing: 'Libre gamitin ang site.',
    pricingDetail: 'Pero kailangan din naming mabuhay – paki-consider mag-donate.'
  },
  wall: {
    title: 'Ang Pader',
    subtitle: 'Dito mo makikita ang mga post mula sa komunidad.',
    writePost: 'SUMULAT SA PADER',
    placeholder: 'Isulat ang iyong post dito...',
    group: 'Grupo',
    noGroup: 'Walang grupo',
    selectImage: 'Pumili ng larawan',
    noFileSelected: 'Walang napiling file.',
    send: 'I-post',
    public: 'Pampubliko',
    members: 'Mga Miyembro',
    private: 'Pribado',
    visibility: 'Visibility'
  },
  groups: {
    title: 'Mga Grupo',
    subtitle: 'Mga grupo na may kahulugan – lokal, libangan, paglalakbay, lakad – madaling sundan.',
    createGroup: 'Gumawa ng grupo',
    allGroups: 'Lahat ng grupo',
    myGroups: 'Aking mga grupo',
    searchPlaceholder: 'Maghanap ng mga grupo...',
    noGroups: 'Walang nakitang grupo',
    noMyGroups: 'Hindi ka pa miyembro ng anumang grupo',
    groupName: 'Pangalan ng grupo',
    description: 'Paglalarawan',
    publicGroup: 'Pampublikong grupo (lahat ay makakakita at makakasali)',
    private: 'Pribado',
    createdBy: 'Ginawa ni',
    members: 'mga miyembro',
    postsCount: 'mga post',
    noDescription: 'Walang paglalarawan',
    join: 'Sumali',
    leave: 'Umalis',
    open: 'Buksan',
    leaveConfirm: 'Sigurado ka bang gusto mong umalis sa grupong ito?',
    postsTab: 'Mga Post',
    membersTab: 'Mga Miyembro',
    noPosts: 'Wala pang mga post sa grupong ito',
    joinToSee: 'Sumali sa grupo para makita ang mga post',
    about: 'Tungkol sa',
    createdOn: 'Ginawa noong',
    editGroup: 'I-edit ang grupo',
    deleteConfirm: 'Sigurado ka bang gusto mong burahin ang grupong ito? Lahat ng post ay mabubura.',
    setMember: 'Itakda bilang miyembro',
    setModerator: 'Itakda bilang moderator',
    setAdmin: 'Itakda bilang admin',
    removeMember: 'Alisin sa grupo',
    removeMemberConfirm: 'Sigurado ka bang gusto mong alisin si {name} sa grupo?',
    changeCover: 'Palitan ang cover image',
    invalidImageType: 'Hindi valid ang uri ng file. Pumili ng larawan.',
    imageTooLarge: 'Masyadong malaki ang larawan. Maximum 5MB.'
  },
  profile: {
    title: 'Aking Profile',
    editProfile: 'I-edit ang profile',
    myPosts: 'Aking mga post',
    myGroups: 'Aking mga grupo',
    overview: 'Pangkalahatang-ideya',
    edit: 'I-edit',
    settings: 'Mga Setting',
    activity: 'Aktibidad',
    bio: 'Tungkol sa akin',
    location: 'Lokasyon',
    website: 'Website',
    birthday: 'Kaarawan',
    interests: 'Mga Interes',
    joined: 'Sumali noong',
    posts: 'Mga Post',
    comments: 'Mga Komento',
    reactions: 'Mga Reaksyon',
    privacy: 'Privacy',
    showRealName: 'Ipakita ang tunay na pangalan sa publiko',
    showEmail: 'Ipakita ang e-mail sa publiko',
    emailNotifications: 'Mga notification sa e-mail',
    changePassword: 'Palitan ang password',
    currentPassword: 'Kasalukuyang password',
    newPassword: 'Bagong password',
    confirmPassword: 'Kumpirmahin ang password',
    uploadAvatar: 'Mag-upload ng profile picture',
    changeAvatar: 'Palitan ang profile picture',
    removeAvatar: 'Alisin ang profile picture',
    bioPlaceholder: 'Magkuwento tungkol sa iyong sarili...',
    interestsPlaceholder: 'Ano ang mga interes mo?',
    saveChanges: 'I-save ang mga pagbabago',
    cancelChanges: 'Kanselahin',
    profileUpdated: 'Na-update na ang profile!',
    passwordChanged: 'Napalitan na ang password!',
    avatarUploaded: 'Na-upload na ang profile picture!',
    recentPosts: 'Mga kamakailang post',
    recentComments: 'Mga kamakailang komento',
    recentReactions: 'Mga kamakailang reaksyon',
    noPosts: 'Wala pang mga post',
    noComments: 'Wala pang mga komento',
    noReactions: 'Wala pang mga reaksyon',
    downloadData: 'I-download ang aking data',
    deleteAccount: 'Burahin ang account',
    deleteAccountWarning: 'Permanenteng mabubura ang iyong account at lahat ng data. Hindi na ito maaaring i-undo.',
    age: 'taong gulang'
  },
  common: {
    loading: 'Naglo-load...',
    error: 'May naganap na error',
    success: 'Tagumpay!',
    cancel: 'Kanselahin',
    save: 'I-save',
    delete: 'Burahin',
    edit: 'I-edit',
    post: 'I-post',
    comment: 'Komento',
    quote: 'I-quote',
    reply: 'Sumagot',
    confirm: 'Kumpirmahin',
    ok: 'OK',
    data: 'Data',
    noComments: 'Wala pang mga komento. Maging una!',
    writeComment: 'Magsulat ng komento...',
    replyToComment: 'Sumagot sa komento...',
    deleteConfirm: 'Burahin ang post na ito?',
    contentRequired: 'Hindi maaaring walang laman',
    updateFailed: 'Hindi ma-update ang post',
    deleteFailed: 'Hindi mabura ang post',
    commentFailed: 'Hindi maipadala ang komento'
  },
  users: {
    searchTitle: 'Maghanap ng mga gumagamit',
    searchSubtitle: 'Maghanap ng mga gumagamit sa komunidad',
    searchPlaceholder: 'Maghanap ayon sa username, pangalan o email...',
    search: 'Maghanap',
    searchHint: 'Mag-type ng hindi bababa sa 2 karakter para maghanap ng mga gumagamit',
    resultsFound: '{count} (mga) gumagamit ang nahanap',
    noResults: 'Walang nahanap na mga gumagamit. Subukan ang ibang salita.'
  },
  validation: {
    required: 'Kinakailangan ang field na ito',
    email: 'Maglagay ng valid na e-mail',
    maxLength: 'Maximum {max} na karakter',
    passwordMatch: 'Dapat magkatugma ang mga password'
  }
}
